export default {
  DpAttemptItem: {
    scored: 'Scored',
    partially_scored: 'Partially Scored',
    submitted: 'Submitted',
    not_scored: 'Not Scored',
    notScoredTooltip: 'Your teacher has not released scores for this assessment yet.',
    rowAriaLabel: 'Row {{index}} of {{total}}, {{assessmentName}}, scored on {{date}} with {{score}}%, click to see details'
  }
};